import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBKkv6gXaGS3mztETCde4r1xIelacpPVT0",
  authDomain: "webtek-77f0e.firebaseapp.com",
  projectId: "webtek-77f0e",
  storageBucket: "webtek-77f0e.firebasestorage.app",
  messagingSenderId: "779321066778",
  appId: "1:779321066778:web:52e3c649cb8e86fcc118a3",
  measurementId: "G-LZHM0QJG08"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// Optional: Callable function
export const logBollingerEvent = httpsCallable(functions, "logBollingerEvent");
